<div class="label-seeding" *ngIf="loaded">
  <h3 class="label-seeding__title">{{ 'settings.label_seeding.title' | translate }}</h3>
  <p class="label-seeding__hint">{{ 'settings.label_seeding.hint' | translate }}</p>

  <div class="label-seeding__switches">
    <mat-slide-toggle
      *ngFor="let source of sources"
      color="primary"
      [checked]="flags[source]"
      [disabled]="saving !== null"
      [attr.data-testid]="'label-seeding-' + source"
      (change)="toggle(source, $event.checked)">
      {{ 'settings.label_seeding.' + source | translate }}
    </mat-slide-toggle>
  </div>
</div>
